export enum CommentsTypeEnum {
  Comment,
  Doubt,
  Answer,
}

export enum CommentsStatusEnum {
  Approved, // Aprovado
  Pending, // Pendente
  Reproved, // Reprovado
  Blocked, // Bloqueado
}

export enum CommentsReportEnum {
  PersonalAttack, // Ataque pessoal
  HateSpeech, // Discusso de ódio
  Language, // Linguagem inapropriada
  Spam, // Spam ou fraude
  FakeNews, // Informação falsa
  SexualActivity, // Atividade sexual
  Other, // Outros
}

export enum CommentsReactionEnum {
  Liked = 0, // Gostou
  Loved = 1, // Amou
  Disliked = 9999, // Não gostou
}

export type CommentsActions = 'edit' | 'reply';

export interface CommentsReportItem {
  customerUuid: string;
  report: CommentsReportEnum;
}

export interface CommentsReactionItem {
  reaction: CommentsReactionEnum;
  reactedBy: string;
}

export interface CommentsItem {
  uuid: string;
  text: string;
  customerUuid: string;
  publicPersonaUuid: string;
  isHtml: boolean;
  commentType: CommentsTypeEnum;
  commentStatus: CommentsStatusEnum;
  postedAt: string;
  postedBy: string;
  wasEdited: boolean;
  canBeEdited: boolean;
  reports: CommentsReportItem[];
  answers: CommentsItem[];
  reactions: CommentsReactionItem[];
}

export interface CommentsResponse {
  comments: CommentsItem[];
}

export interface CommentsConfig {
  enableComments: boolean | null;
  enableCommentsAutoAproval: boolean | null;
  enableCommentsAnswersAutoAppoval: boolean | null;
  enableCommentsReactionLike: boolean | null;
  enableCommentsReactionLove: boolean | null;
  enableCommentsReactionSupport: boolean | null;
  enableCommentsReactionFunny: boolean | null;
  enableCommentsReactionGenius: boolean | null;
  enableCommentsReactionInteresting: boolean | null;
  enableCommentsReactionDislike: boolean | null;
}

export type CommentsState = CommentsResponse & {
  replyingCommentUuid: string;
  commentTypeFilter: CommentsTypeEnum | null;
  reportingCommentUuid: string;
  commentsConfig: CommentsConfig;
  fetchedComments: boolean;
};

export interface SendCommentsProps {
  text: string;
  commentType: CommentsTypeEnum;
  publicPersonaUuid?: string;
}
